/**
 * O contrato da API de prazos do sistema (`bff/v1/admin/prazos-sistema`,
 * migração 0321).
 */

/**
 * A unidade em que um prazo é contado.
 *
 * Espelha o tipo enumerado `unidade_prazo` de `db/migrations/0002_dominio_base.sql`
 * (CLAUDE.md, "Regras de banco", item 8).
 */
export const UNIDADES_DE_PRAZO = ['DIAS_CORRIDOS', 'DIAS_UTEIS', 'MESES', 'ANOS'] as const;

export type UnidadeDePrazo = (typeof UNIDADES_DE_PRAZO)[number];

export const ROTULO_DA_UNIDADE: Record<UnidadeDePrazo, string> = {
  DIAS_CORRIDOS: 'Dias corridos',
  DIAS_UTEIS: 'Dias úteis',
  MESES: 'Meses',
  ANOS: 'Anos',
};

/** Teto do prazo, o mesmo do banco (`ck_prazos_sistema_valor_max`). */
export const PRAZO_MAXIMO = 3650;

/** Um prazo parametrizável. */
export interface PrazoDoSistema {
  id: string;
  chave: string;
  categoria: string;
  descricao: string;
  valor: number;
  unidade: UnidadeDePrazo;
  observacoes: string | null;
  ativo: boolean;
  ordem: number;
  /** Número da edição, devolvido na alteração para a API recusar edição desatualizada. */
  versao: number;
  /** O que no sistema lê este prazo; `null` quando nada lê (e então ele pode ser desativado). */
  usadoPor: string | null;
  /** Unidade que a regra exige, quando ela ignora a unidade da linha; senão `null`. */
  unidadeFixa: UnidadeDePrazo | null;
  atualizadoEm: string;
}

export interface ListaDePrazos {
  itens: PrazoDoSistema[];
  total: number;
  pagina: number;
  tamanho: number;
}

export interface AlteracaoDoPrazo {
  versao: number;
  valor: number;
  unidade: UnidadeDePrazo;
  ativo: boolean;
  observacoes: string | null;
}
